import getRecaptchaKey from './getRecaptchaKey';

/**
 * @module google-recaptcha/renderRecaptchaWidget
 * @description
 * Рендер рекапчи
 * @param {DOMElement} container - блок для рендера рекапчи
 * @param {string} formType - тип формы
 * @param {object} context - контекст
 * @param {boolean} isInvisible - флаг невидимой капчи
 *
 * @returns {void}
 */
export default (container, formType, context, isInvisible) => {
  const recaptchaVerify = function(response) {
    const recaptchaTokenInput = container.querySelector(`[name="${formType}[g-recaptcha-response]"]`);

    if (recaptchaTokenInput) {
      recaptchaTokenInput.value = response;
    } else {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `[name="${formType}[g-recaptcha-response]"]`;
      input.value = response;
      container.appendChild(input);
    }

    const gRecaptchaResponse = container.querySelector('#g-recaptcha-response');

    if (gRecaptchaResponse) {
      gRecaptchaResponse.value = response;
    }

    // Используем везде это событие
    window.EventBus.publish('google-recaptcha:insales:response', {
      response,
      container
    });

    // Оставляем для обратной совместимости, чтобы не сломать в старых формах
    window.EventBus.publish('recaptcha:insales:response', response);
  };

  let grecaptchaWidgetId = window.grecaptcha.render(container, {
    sitekey: getRecaptchaKey(container),
    callback: !isInvisible ? recaptchaVerify : 'recaptchaVerifyV3'
  });

  container.dataset.googleRecaptchaWidgetId = grecaptchaWidgetId;

  if (context && context.settings) {
    context.settings.recaptchaWidgets.push(grecaptchaWidgetId);
    window.grecaptchaWidget = grecaptchaWidgetId;
  }

  return;
};
